import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.83337 14.1775L9.51087 14.165L17.5375 6.21502C17.8525 5.90002 18.0259 5.48169 18.0259 5.03669C18.0259 4.59169 17.8525 4.17335 17.5375 3.85835L16.2159 2.53669C15.5859 1.90669 14.4867 1.91002 13.8617 2.53419L5.83337 10.4859V14.1775ZM15.0375 3.71502L16.3617 5.03419L15.0309 6.35252L13.7092 5.03169L15.0375 3.71502ZM7.50004 11.1809L12.525 6.20335L13.8467 7.52502L8.82254 12.5009L7.50004 12.505V11.1809Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.16667 17.5H15.8333C16.7525 17.5 17.5 16.7525 17.5 15.8333V8.61L15.8333 10.2767V15.8333H6.79833C6.77667 15.8333 6.75417 15.8417 6.7325 15.8417C6.705 15.8417 6.6775 15.8342 6.64917 15.8333H4.16667V4.16667H9.8725L11.5392 2.5H4.16667C3.2475 2.5 2.5 3.2475 2.5 4.16667V15.8333C2.5 16.7525 3.2475 17.5 4.16667 17.5Z",
		fill: "currentColor"
	})]
});
export default SvgEdit;
